import React, { useState, useEffect, useCallback, useRef } from 'react';

/* ── Google Font ────────────────────────────────────────────────────────────*/
const _fl = document.createElement('link');
_fl.rel  = 'stylesheet';
_fl.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap';
if (!document.head.querySelector('[href*="DM+Sans"]')) document.head.appendChild(_fl);

/* ── Navia Logo ─────────────────────────────────────────────────────────────*/
const NAVIA_LOGO = 'data:image/png;base64,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';

/* ── Helpers ────────────────────────────────────────────────────────────────*/
function fmtIST(val) {
  if (!val) return '—';
  return new Date(val).toLocaleString('en-IN', {
    timeZone:'Asia/Kolkata', day:'2-digit', month:'short',
    hour:'2-digit', minute:'2-digit', hour12:true
  });
}
function fmtQty(v) { return v == null ? '0' : Number(v).toString(); }

function authHeader() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('nb_dealer_token') || ''}`
  };
}

/* ── Status badge — mirrors Dashboard.jsx (client view) exactly ─────────────
 * FILE_GENERATED is admin-internal — dealer still sees it as "Order received"
 * for consistency with what the client sees, avoiding confusion when a dealer
 * cross-checks what the client is seeing on their own login. */
function statusBadge(status) {
  const s = (status || '').toUpperCase();
  if (s === 'ORDER_RECEIVED' || s === 'RECEIVED' || s === 'FILE_GENERATED')
    return { label:'Order received',   bg:'#EEF2FF', col:'#1338A8' };
  if (s === 'PARTIALLY_TRADED')
    return { label:'Partially traded', bg:'#FFFBEB', col:'#92400E' };
  if (s === 'ORDER_TRADED' || s === 'TRADED')
    return { label:'Traded',           bg:'#E1F5EE', col:'#085041' };
  if (s === 'REJECTED')
    return { label:'Rejected',         bg:'#FEF2F2', col:'#991B1B' };
  return { label:'Order received', bg:'#EEF2FF', col:'#1338A8' };
}

/* ═══════════════════════════════════════════════════════════════════════════*/
export default function DealerDashboard({ dealer, onLogout }) {

  /* ── View state: 'search' | 'client' ─────────────────────────────────────*/
  const [view,          setView]          = useState('search');
  const [clientData,    setClientData]    = useState(null);
  const [loadingClient, setLoadingClient] = useState(false);

  /* ── Search state ─────────────────────────────────────────────────────────*/
  const [ucc,         setUcc]         = useState('');
  const [searchError, setSearchError] = useState('');
  const [recentList,  setRecentList]  = useState([]);
  const [loadingRecent, setLoadingRecent] = useState(true);

  /* ── Client view state ───────────────────────────────────────────────────*/
  const [activeTab,    setActiveTab]   = useState('positions');
  const [placing,      setPlacing]     = useState(false);
  const [confirmModal, setConfirmModal]= useState(null);
  const [message,      setMessage]     = useState('');
  const [msgType,      setMsgType]     = useState('success');

  const dealerToken = localStorage.getItem('nb_dealer_token') || '';

  /* ── Load recent clients from DB on mount ─────────────────────────────────*/
  useEffect(() => {
    fetch('/api/dealer/recent-clients', { headers: authHeader() })
      .then(r => {
        // On 401 just show empty list — don't log out (token may be in flight)
        if (!r.ok) return { success: true, clients: [] };
        return r.json();
      })
      .then(d => {
        if (d?.success) setRecentList(d.clients || []);
      })
      .catch(() => {})
      .finally(() => setLoadingRecent(false));
  }, []);

  /* ── Session expiry handler ──────────────────────────────────────────────*/
  const handleExpiry = useCallback(() => {
    localStorage.removeItem('nb_dealer_token');
    localStorage.removeItem('nb_dealer');
    onLogout();
  }, [onLogout]);

  /* ── Load client data (same page) ────────────────────────────────────────*/
  const loadClient = useCallback(async (targetUCC) => {
    const uccClean = (targetUCC || ucc).trim().toUpperCase();
    if (!uccClean) { setSearchError('Please enter a UCC.'); return; }

    setLoadingClient(true);
    setSearchError('');
    try {
      const r = await fetch('/api/dealer/client-data', {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ ucc: uccClean })
      });

      if (r.status === 401) { handleExpiry(); return; }

      const d = await r.json();
      if (!d.success) {
        setSearchError(d.error || 'Client not found.');
        return;
      }

      setClientData(d);
      setView('client');
      setActiveTab('positions');
      setUcc('');
      setMessage('');

    } catch (err) {
      setSearchError('Network error. Please try again.');
    } finally {
      setLoadingClient(false);
    }
  }, [ucc, handleExpiry]);

  /* ── Refresh client data ─────────────────────────────────────────────────*/
  const refreshClientData = useCallback(async () => {
    if (!clientData?.client?.ucc) return;
    setLoadingClient(true);
    try {
      const r = await fetch('/api/dealer/client-data', {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ ucc: clientData.client.ucc })
      });
      if (r.status === 401) { handleExpiry(); return; }
      const d = await r.json();
      if (d.success) setClientData(d);
    } catch {}
    finally { setLoadingClient(false); }
  }, [clientData, handleExpiry]);

  /* ── Place sq-off ────────────────────────────────────────────────────────*/
  const placeSquareOff = useCallback(async () => {
    if (!confirmModal) return;
    setPlacing(true);
    try {
      const r = await fetch('/api/dealer/place-squareoff', {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({
          ucc:          clientData.client.ucc,
          exchange:     confirmModal.exchange,
          segment:      confirmModal.segment,
          symbol:       confirmModal.symbol,
          quantity:     confirmModal.quantity,
          side:         confirmModal.side,
          expiry_date:  confirmModal.expiry_date  || null,
          strike_price: confirmModal.strike_price || null,
          option_type:  confirmModal.option_type  || null,
        })
      });
      if (r.status === 401) { handleExpiry(); return; }
      const d = await r.json();

      if (d.success) {
        setMessage(`Square-off placed for ${confirmModal.symbol}. Order: ${d.orderId}`);
        setMsgType('success');
        setConfirmModal(null);
        // Refresh data from server — ensures sq-off state is accurate
        await refreshClientData();
      } else {
        setMessage(d.message || d.error || 'Failed to place order.');
        setMsgType('error');
        setConfirmModal(null);
      }
    } catch (err) {
      setMessage('Network error. Please retry.');
      setMsgType('error');
      setConfirmModal(null);
    } finally {
      setPlacing(false);
      setTimeout(() => setMessage(''), 6000);
    }
  }, [confirmModal, clientData, handleExpiry, refreshClientData]);

  /* ── Check if order already placed (from server data) ───────────────────*/
  function isPlaced(symbol, exchange, segment) {
    if (!clientData?.orders) return false;
    // Only block sq-off button for ACTIVE orders (not already traded/rejected)
    const activeStatuses = ['ORDER_RECEIVED','PARTIALLY_TRADED'];
    return clientData.orders.some(o =>
      o.symbol === symbol &&
      o.exchange === exchange &&
      o.segment === segment &&
      activeStatuses.includes((o.status||'').toUpperCase())
    );
  }

  function getOrderStatus(symbol, exchange, segment) {
    if (!clientData?.orders) return null;
    return clientData.orders.find(o =>
      o.symbol === symbol &&
      o.exchange === exchange &&
      o.segment === segment
    );
  }

  /* ── Styles ──────────────────────────────────────────────────────────────*/
  const s = {
    page:    { minHeight:'100vh', background:'#F4F6F9', fontFamily:"'DM Sans',-apple-system,sans-serif", fontSize:13, color:'#0D0F12' },
    topbar:  { background:'#fff', borderBottom:'0.5px solid #E2E8F0', padding:'0 24px', height:52, display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:50 },
    card:    { background:'#fff', border:'0.5px solid #E2E8F0', borderRadius:12, overflow:'hidden', marginBottom:14 },
    th:      { background:'#F8FAFC', borderBottom:'0.5px solid #E2E8F0', color:'#64748B', fontSize:10, fontWeight:600, padding:'8px 12px', textAlign:'left', textTransform:'uppercase', letterSpacing:'.04em', whiteSpace:'nowrap' },
    td:      { color:'#0D0F12', fontSize:12, padding:'9px 12px', verticalAlign:'middle', borderBottom:'0.5px solid #F1F5F9' },
    tabRow:  { display:'flex', background:'#fff', border:'0.5px solid #E2E8F0', borderRadius:8, overflow:'hidden', marginBottom:14 },
    tabPill: (a) => ({ flex:1, border:'none', background:a?'#1B4FD8':'transparent', color:a?'#fff':'#5A6272', padding:'9px 8px', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }),
    sqBtn:   { background:'#DC2626', color:'#fff', border:'none', borderRadius:6, padding:'6px 12px', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", whiteSpace:'nowrap' },
    placed:  { background:'#FFFBEB', color:'#92400E', border:'0.5px solid #D97706', borderRadius:6, fontSize:10, fontWeight:600, padding:'4px 10px', whiteSpace:'nowrap' },
    input:   { flex:1, padding:'11px 14px', borderRadius:8, border:'1.5px solid #E2E8F0', background:'#F8FAFC', color:'#0D0F12', fontSize:14, fontWeight:500, outline:'none', fontFamily:"'DM Sans',sans-serif" },
    btnPri:  { padding:'11px 24px', borderRadius:8, border:'none', background:'#1B4FD8', color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", whiteSpace:'nowrap' },
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:16 },
    modal:   { background:'#fff', borderRadius:14, width:'100%', maxWidth:420, border:'0.5px solid #E2E8F0' },
  };

  /* ── Topbar (shared) ─────────────────────────────────────────────────────*/
  const Topbar = () => (
    <header style={s.topbar}>
      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
        <div style={{ background:'#fff', borderRadius:7, padding:'3px 10px', boxShadow:'0 1px 4px rgba(0,0,0,.10)', display:'flex', alignItems:'center' }}>
          <img src={NAVIA_LOGO} alt='Navia' style={{ height:22, width:'auto', objectFit:'contain' }}/>
        </div>
        <span style={{ fontSize:13, fontWeight:600, color:'#0D0F12' }}>Navia Backup</span>
        <span style={{ color:'#CBD5E0', fontSize:12 }}>|</span>
        <span style={{ fontSize:12, color:'#64748B' }}>Dealer Portal</span>
        {view === 'client' && clientData && (
          <>
            <span style={{ color:'#CBD5E0' }}>›</span>
            <span style={{ fontSize:12, fontWeight:600, color:'#1B4FD8' }}>
              {clientData.client.client_name} ({clientData.client.ucc})
            </span>
          </>
        )}
      </div>
      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
        <span style={{ background:'#FFF7ED', color:'#C2410C', border:'0.5px solid #FED7AA', padding:'3px 10px', borderRadius:4, fontSize:11, fontWeight:600 }}>
          DEALER: {dealer.dealer_id}
        </span>
        <span style={{ fontSize:12, color:'#64748B' }}>{dealer.name}</span>
        <button onClick={() => { localStorage.removeItem('nb_dealer_token'); localStorage.removeItem('nb_dealer'); onLogout(); }}
          style={{ padding:'5px 12px', borderRadius:6, border:'0.5px solid #E2E8F0', background:'#fff', color:'#64748B', fontSize:11, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
          Sign out
        </button>
      </div>
    </header>
  );

  /* ══════════════════════════════════════════════════════════════════════════
     SEARCH VIEW
  ══════════════════════════════════════════════════════════════════════════*/
  if (view === 'search') return (
    <div style={s.page}>
      <Topbar/>

      <div style={{ maxWidth:600, margin:'40px auto', padding:'0 20px' }}>

        {/* Search card */}
        <div style={{ background:'#fff', border:'0.5px solid #E2E8F0', borderRadius:14, padding:32, marginBottom:20, boxShadow:'0 1px 4px rgba(0,0,0,.04)' }}>
          <div style={{ fontSize:17, fontWeight:600, marginBottom:4 }}>Client UCC Search</div>
          <div style={{ fontSize:12, color:'#64748B', marginBottom:20 }}>
            Enter UCC to load client positions in this page. All sq-off orders are tracked by server.
          </div>

          <div style={{ display:'flex', gap:10 }}>
            <input style={s.input}
              type="text" value={ucc} placeholder="Enter Client UCC e.g. 99405185"
              onChange={e => { setUcc(e.target.value.toUpperCase()); setSearchError(''); }}
              onKeyDown={e => e.key === 'Enter' && loadClient()}
              onFocus={e => e.target.style.borderColor = '#1B4FD8'}
              onBlur={e => e.target.style.borderColor = '#E2E8F0'}
              autoFocus
            />
            <button style={{ ...s.btnPri, opacity: loadingClient || !ucc.trim() ? 0.6 : 1, cursor: loadingClient || !ucc.trim() ? 'not-allowed':'pointer' }}
              onClick={() => loadClient()} disabled={loadingClient || !ucc.trim()}>
              {loadingClient ? 'Loading…' : '→ Load Client'}
            </button>
          </div>

          {searchError && (
            <div style={{ marginTop:10, color:'#DC2626', fontSize:12, background:'#FEF2F2', border:'0.5px solid #FECACA', padding:'8px 12px', borderRadius:6 }}>
              ⚠ {searchError}
            </div>
          )}

          <div style={{ marginTop:14, background:'#F8FAFC', borderRadius:8, padding:'10px 14px', fontSize:11, color:'#64748B', lineHeight:1.7 }}>
            <strong style={{ color:'#374151' }}>Security note:</strong> Client data loads in this page. Sq-off state is always verified from server — switching between clients shows accurate order status from database.
          </div>
        </div>

        {/* Recent clients */}
        {!loadingRecent && recentList.length > 0 && (
          <div style={{ ...s.card }}>
            <div style={{ padding:'12px 16px', borderBottom:'0.5px solid #E2E8F0', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <div style={{ fontSize:13, fontWeight:600 }}>Recent clients</div>
              <div style={{ fontSize:11, color:'#94A3B8' }}>Persistent · from database</div>
            </div>
            {recentList.map((r, i) => (
              <div key={r.ucc} onClick={() => loadClient(r.ucc)}
                style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'11px 16px', cursor:'pointer', borderBottom: i < recentList.length-1 ? '0.5px solid #F1F5F9':'none', transition:'background .15s' }}
                onMouseEnter={e => e.currentTarget.style.background='#F8FAFF'}
                onMouseLeave={e => e.currentTarget.style.background='#fff'}>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <div style={{ width:32, height:32, borderRadius:'50%', background:'#EEF2FF', color:'#1B4FD8', fontSize:12, fontWeight:700, display:'flex', alignItems:'center', justifyContent:'center' }}>
                    {(r.client_name||r.ucc)[0]}
                  </div>
                  <div>
                    <div style={{ fontSize:13, fontWeight:500 }}>{r.client_name || r.ucc}</div>
                    <div style={{ fontSize:11, color:'#64748B' }}>UCC: {r.ucc}</div>
                  </div>
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <span style={{ fontSize:10, color:'#94A3B8' }}>{fmtIST(r.last_accessed)}</span>
                  <span style={{ fontSize:11, color:'#1B4FD8', fontWeight:500 }}>→ Load</span>
                </div>
              </div>
            ))}
          </div>
        )}

        {loadingRecent && (
          <div style={{ textAlign:'center', color:'#94A3B8', fontSize:12, padding:20 }}>Loading recent clients…</div>
        )}
      </div>
    </div>
  );

  /* ══════════════════════════════════════════════════════════════════════════
     CLIENT VIEW
  ══════════════════════════════════════════════════════════════════════════*/
  const client   = clientData?.client   || {};
  const orders   = clientData?.orders   || [];
  const dayPos   = clientData?.day_positions || [];
  const bfPos    = clientData?.bf_positions  || [];
  const holdings = clientData?.holdings      || [];

  // Net positions tab = FAO ONLY (per spec: EQ sq-off is via Day positions tab)
  // These are the actual FAO positions available for square-off
  const positions = dayPos.filter(p => Number(p.net_qty) !== 0 && p.instrument_type !== 'EQUITY');

  const dayFO    = dayPos.filter(p => p.instrument_type !== 'EQUITY');
  const dayEQ    = dayPos.filter(p => p.instrument_type === 'EQUITY');
  const bfOpts   = bfPos.filter(p => p.instrument_type === 'OPTIONS');
  const bfFuts   = bfPos.filter(p => p.instrument_type === 'FUTURES');

  return (
    <div style={s.page}>

      {/* Confirm modal */}
      {confirmModal && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={{ padding:'16px 20px', borderBottom:'0.5px solid #E2E8F0' }}>
              <div style={{ fontSize:15, fontWeight:600 }}>Confirm square-off</div>
              <div style={{ fontSize:11, color:'#64748B', marginTop:2 }}>Placing on behalf of {client.client_name} ({client.ucc})</div>
            </div>
            <div style={{ padding:'16px 20px' }}>
              {[
                ['Symbol',   confirmModal.symbol + (confirmModal.strike_price ? ` ₹${confirmModal.strike_price} ${confirmModal.option_type||''}` : '')],
                ['Exchange', `${confirmModal.exchange} / ${confirmModal.segment}`],
                ['Side',     confirmModal.side],
                ['Quantity', confirmModal.quantity],
                ['Order',    'MARKET'],
              ].map(([l,v],i) => (
                <div key={i} style={{ display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'0.5px solid #F1F5F9' }}>
                  <span style={{ fontSize:12, color:'#64748B' }}>{l}</span>
                  <span style={{ fontSize:12, fontWeight:500, color: l==='Side'?'#DC2626':'#0D0F12' }}>{v}</span>
                </div>
              ))}
              <div style={{ marginTop:12, background:'#FEF2F2', border:'0.5px solid #FECACA', borderRadius:6, padding:'8px 12px', fontSize:11, color:'#991B1B' }}>
                Market order — cannot be cancelled after placing.
              </div>
            </div>
            <div style={{ padding:'12px 20px', borderTop:'0.5px solid #E2E8F0', display:'flex', gap:10 }}>
              <button style={{ flex:1, height:38, background:'#fff', border:'0.5px solid #E2E8F0', borderRadius:8, fontSize:12, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }} onClick={()=>setConfirmModal(null)} disabled={placing}>Cancel</button>
              <button style={{ flex:2, height:38, background:'#DC2626', border:'none', borderRadius:8, color:'#fff', fontSize:13, fontWeight:600, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }} onClick={placeSquareOff} disabled={placing}>
                {placing ? 'Placing…' : 'Confirm square-off'}
              </button>
            </div>
          </div>
        </div>
      )}

      <Topbar/>

      <div style={{ maxWidth:1100, margin:'0 auto', padding:'18px 20px' }}>

        {/* Back + client info bar */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:14, flexWrap:'wrap', gap:8 }}>
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <button onClick={() => { setView('search'); setClientData(null); setMessage(''); }}
              style={{ background:'none', border:'0.5px solid #E2E8F0', borderRadius:6, padding:'5px 12px', fontSize:12, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", color:'#374151', display:'flex', alignItems:'center', gap:4 }}>
              ← Back to search
            </button>
            <div style={{ fontSize:13, fontWeight:600 }}>{client.client_name}</div>
            <div style={{ background:'#EEF2FF', color:'#1B4FD8', border:'0.5px solid #C7D2FE', borderRadius:4, padding:'2px 9px', fontSize:11, fontWeight:600 }}>
              UCC: {client.ucc}
            </div>
            <div style={{ background:'#FFF7ED', color:'#C2410C', border:'0.5px solid #FED7AA', borderRadius:4, padding:'2px 9px', fontSize:11, fontWeight:600 }}>
              DEALER: {clientData?.dealerId}
            </div>
          </div>
          <button onClick={refreshClientData} disabled={loadingClient}
            style={{ background:'#EEF2FF', color:'#1B4FD8', border:'0.5px solid #C7D2FE', borderRadius:7, padding:'6px 14px', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", display:'flex', alignItems:'center', gap:6 }}>
            {loadingClient ? '…' : '↻'} Refresh
          </button>
        </div>

        {/* Message banner */}
        {message && (
          <div style={{ background:msgType==='success'?'#E1F5EE':'#FEF2F2', border:`0.5px solid ${msgType==='success'?'#1D9E75':'#DC2626'}`, color:msgType==='success'?'#085041':'#991B1B', borderRadius:8, padding:'9px 14px', fontSize:12, marginBottom:12 }}>
            {message}
          </div>
        )}

        {/* Tab bar */}
        <nav style={s.tabRow}>
          {[
            { key:'positions', label:`Net (${positions.length})` },
            { key:'day',       label:`Day (${dayPos.length})` },
            { key:'bf',        label:`B/F (${bfPos.length})` },
            { key:'holdings',  label:`Holdings (${holdings.length})` },
            { key:'orders',    label:`Orders (${orders.length})` },
          ].map((t,i) => (
            <button key={t.key} style={{ ...s.tabPill(activeTab===t.key), borderRight: i<4?'0.5px solid #E2E8F0':'none' }}
              onClick={()=>setActiveTab(t.key)}>{t.label}</button>
          ))}
        </nav>

        {/* ── NET POSITIONS ──────────────────────────────────────────────── */}
        {activeTab === 'positions' && (
          <div style={s.card}>
            {positions.length === 0
              ? <div style={{ padding:40, textAlign:'center', color:'#94A3B8' }}>No open net positions found for today.</div>
              : <div style={{ overflowX:'auto' }}>
                  <table style={{ width:'100%', borderCollapse:'collapse', minWidth:620 }}>
                    <thead><tr>
                      {['Symbol & Strike','Expiry','Type','Buy qty','Sell qty','Net qty','Exchange','Action'].map(h=><th key={h} style={s.th}>{h}</th>)}
                    </tr></thead>
                    <tbody>
                      {positions.map((p,i) => {
                        const netQty = Number(p.net_qty);
                        const side   = netQty > 0 ? 'SELL' : 'BUY';
                        const qty    = Math.abs(netQty);
                        const placed = isPlaced(p.symbol, p.exchange, p.segment);
                        const ord    = getOrderStatus(p.symbol, p.exchange, p.segment);
                        return (
                          <tr key={i}>
                            <td style={{ ...s.td, fontWeight:600 }}>
                              {p.symbol}
                              {p.strike_price ? <span style={{fontSize:10,color:'#64748B',marginLeft:4}}>₹{p.strike_price} {p.option_type||''}</span> : null}
                            </td>
                            <td style={{...s.td,fontSize:11,color:'#64748B'}}>
                              {p.expiry_date ? new Date(p.expiry_date).toLocaleDateString('en-IN') : '—'}
                            </td>
                            <td style={s.td}>{p.option_type || 'FUT'}</td>
                            <td style={{ ...s.td, color:'#059669' }}>{fmtQty(p.buy_qty)}</td>
                            <td style={{ ...s.td, color:'#DC2626' }}>{fmtQty(p.sell_qty)}</td>
                            <td style={{ ...s.td, fontWeight:600, color:netQty>0?'#059669':netQty<0?'#DC2626':'#64748B' }}>{netQty}</td>
                            <td style={s.td}>{p.exchange}</td>
                            <td style={s.td}>
                              {ord && ['ORDER_TRADED','PARTIALLY_TRADED'].includes((ord.status||'').toUpperCase())
                                ? <span style={{...s.placed, background:ord.status==='ORDER_TRADED'?'#E1F5EE':'#FFFBEB', color:ord.status==='ORDER_TRADED'?'#085041':'#92400E', borderColor:ord.status==='ORDER_TRADED'?'#1D9E75':'#D97706'}}>
                                    {ord.status === 'ORDER_TRADED' ? 'Traded' : 'Partial'}
                                  </span>
                                : placed
                                  ? <span style={s.placed}>Order placed</span>
                                  : <button style={s.sqBtn}
                                      onClick={() => setConfirmModal({
                                        symbol:       p.symbol,
                                        exchange:     p.exchange,
                                        segment:      p.segment,
                                        side,
                                        quantity:     qty,
                                        expiry_date:  p.expiry_date  || null,
                                        strike_price: p.strike_price || null,
                                        option_type:  p.option_type  || null,
                                      })}>
                                      Square off
                                    </button>}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>}
          </div>
        )}

        {/* ── DAY POSITIONS ─────────────────────────────────────────────── */}
        {activeTab === 'day' && (
          <div>
            {dayPos.length === 0
              ? <div style={{ ...s.card, padding:40, textAlign:'center', color:'#94A3B8' }}>No day positions.</div>
              : <>
                  {dayEQ.length > 0 && (
                    <div style={s.card}>
                      <div style={{ padding:'9px 14px', borderBottom:'0.5px solid #E2E8F0', fontSize:11, fontWeight:600, color:'#374151' }}>EQUITY — Cash Market</div>
                      <div style={{ overflowX:'auto' }}>
                        <table style={{ width:'100%', borderCollapse:'collapse' }}>
                          <thead><tr>{['Symbol','Buy qty','Sell qty','Net qty','Action'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                          <tbody>
                            {dayEQ.map((p,i) => (
                              <tr key={i}>
                                <td style={{ ...s.td, fontWeight:600 }}>{p.symbol}</td>
                                <td style={{ ...s.td, color:'#059669' }}>{fmtQty(p.buy_qty)}</td>
                                <td style={{ ...s.td, color:'#DC2626' }}>{fmtQty(p.sell_qty)}</td>
                                <td style={{ ...s.td, fontWeight:500 }}>{fmtQty(p.net_qty)}</td>
                                <td style={s.td}>
                                  {(() => {
                                    const ord = getOrderStatus(p.symbol, p.exchange, p.segment);
                                    if (ord && ord.status === 'ORDER_TRADED') return <span style={{...s.placed, background:'#E1F5EE', color:'#085041', borderColor:'#1D9E75'}}>Traded</span>;
                                    if (ord && ord.status === 'PARTIALLY_TRADED') return <span style={{...s.placed, background:'#FFFBEB', color:'#92400E', borderColor:'#D97706'}}>Partial</span>;
                                    if (isPlaced(p.symbol, p.exchange, p.segment)) return <span style={s.placed}>Order placed</span>;
                                    if (Number(p.net_qty) !== 0) return <button style={s.sqBtn} onClick={() => setConfirmModal({ symbol:p.symbol, exchange:p.exchange, segment:p.segment, side:Number(p.net_qty)>0?'SELL':'BUY', quantity:Math.abs(Number(p.net_qty)) })}>Square off</button>;
                                    return <span style={{ color:'#94A3B8', fontSize:11 }}>Flat</span>;
                                  })()}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {dayFO.length > 0 && (
                    <div style={s.card}>
                      <div style={{ padding:'9px 14px', borderBottom:'0.5px solid #E2E8F0', fontSize:11, fontWeight:600, color:'#374151' }}>F&O — View only</div>
                      <div style={{ overflowX:'auto' }}>
                        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:560 }}>
                          <thead><tr>{['Symbol','Expiry','Type','Buy qty','Sell qty','Net qty'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                          <tbody>
                            {dayFO.map((p,i) => (
                              <tr key={i}>
                                <td style={{ ...s.td, fontWeight:600 }}>{p.symbol}{p.strike_price?` ₹${p.strike_price}`:''}</td>
                                <td style={{ ...s.td, fontSize:11, color:'#64748B' }}>{p.expiry_date?new Date(p.expiry_date).toLocaleDateString('en-IN'):'—'}</td>
                                <td style={s.td}>{p.option_type||'FUT'}</td>
                                <td style={{ ...s.td, color:'#059669' }}>{fmtQty(p.buy_qty)}</td>
                                <td style={{ ...s.td, color:'#DC2626' }}>{fmtQty(p.sell_qty)}</td>
                                <td style={{ ...s.td, fontWeight:500 }}>{fmtQty(p.net_qty)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </>}
          </div>
        )}

        {/* ── B/F POSITIONS ─────────────────────────────────────────────── */}
        {activeTab === 'bf' && (
          <div>
            {bfPos.length === 0
              ? <div style={{ ...s.card, padding:40, textAlign:'center', color:'#94A3B8' }}>No B/F positions.</div>
              : <>
                  {bfOpts.length > 0 && (
                    <div style={s.card}>
                      <div style={{ padding:'9px 14px', borderBottom:'0.5px solid #E2E8F0', fontSize:11, fontWeight:600 }}>Options B/F</div>
                      <div style={{ overflowX:'auto' }}>
                        <table style={{ width:'100%', borderCollapse:'collapse', minWidth:480 }}>
                          <thead><tr>{['Symbol','Expiry','Strike','Type','Qty (lots)'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                          <tbody>
                            {bfOpts.map((p,i) => (
                              <tr key={i}>
                                <td style={{ ...s.td, fontWeight:600 }}>{p.symbol}</td>
                                <td style={{ ...s.td, fontSize:11 }}>{p.expiry_date?new Date(p.expiry_date).toLocaleDateString('en-IN'):'—'}</td>
                                <td style={s.td}>{p.strike_price||'—'}</td>
                                <td style={s.td}>{p.option_type}</td>
                                <td style={{ ...s.td, fontWeight:500 }}>{p.qty_in_lots??p.total_open_qty??0}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {bfFuts.length > 0 && (
                    <div style={s.card}>
                      <div style={{ padding:'9px 14px', borderBottom:'0.5px solid #E2E8F0', fontSize:11, fontWeight:600 }}>Futures B/F</div>
                      <div style={{ overflowX:'auto' }}>
                        <table style={{ width:'100%', borderCollapse:'collapse' }}>
                          <thead><tr>{['Symbol','Expiry','Qty (lots)'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                          <tbody>
                            {bfFuts.map((p,i) => (
                              <tr key={i}>
                                <td style={{ ...s.td, fontWeight:600 }}>{p.symbol}</td>
                                <td style={{ ...s.td, fontSize:11 }}>{p.expiry_date?new Date(p.expiry_date).toLocaleDateString('en-IN'):'—'}</td>
                                <td style={{ ...s.td, fontWeight:500 }}>{p.qty_in_lots??p.total_open_qty??0}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </>}
          </div>
        )}

        {/* ── HOLDINGS ──────────────────────────────────────────────────── */}
        {activeTab === 'holdings' && (
          <div style={s.card}>
            {holdings.length === 0
              ? <div style={{ padding:40, textAlign:'center', color:'#94A3B8' }}>No holdings found.</div>
              : <>
                  <div style={{ padding:'9px 14px', borderBottom:'0.5px solid #E2E8F0', fontSize:11, fontWeight:600 }}>NSDL Holdings · View only</div>
                  <div style={{ overflowX:'auto' }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', minWidth:480 }}>
                      <thead><tr>{['Company','Qty','Price','Value','Action'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
                      <tbody>
                        {holdings.map((h,i) => (
                          <tr key={i}>
                            <td style={{ ...s.td, fontWeight:600, fontSize:11 }}>{h.company_name}</td>
                            <td style={s.td}>{h.quantity}</td>
                            <td style={{ ...s.td, color:'#64748B' }}>{h.close_price?`₹${Number(h.close_price).toFixed(2)}`:'—'}</td>
                            <td style={{ ...s.td, color:'#1D9E75', fontWeight:500 }}>{h.total_value?`₹${Number(h.total_value).toLocaleString('en-IN',{maximumFractionDigits:0})}`:'—'}</td>
                            <td style={s.td}>
                              {isPlaced(h.isin||h.company_name,'NSE','CM')
                                ? <span style={s.placed}>Order placed</span>
                                : <button style={s.sqBtn} onClick={()=>setConfirmModal({ symbol:`${h.company_name}`, exchange:'NSE', segment:'CM', side:'SELL', quantity:h.quantity })}>Square off</button>}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>}
          </div>
        )}

        {/* * ── ORDERS ────────────────────────────────────────────────────── */}
        {activeTab === 'orders' && (
          <div style={s.card}>
            {orders.length === 0
              ? <div style={{ padding:40, textAlign:'center', color:'#94A3B8' }}>No orders placed yet in this session.</div>
              : <div style={{ overflowX:'auto' }}>
                  <table style={{ width:'100%', borderCollapse:'collapse', minWidth:560 }}>
                    <thead><tr>
                      {['Symbol','Exchange','Type','Qty','Status','Date & time','Placed by'].map(h=><th key={h} style={s.th}>{h}</th>)}
                    </tr></thead>
                    <tbody>
                      {orders.map((o,i) => {
                        const sb = statusBadge(o.status);
                        return (
                          <tr key={o.order_id||i}>
                            <td style={{ ...s.td, fontWeight:600 }}>
                              {o.symbol}{o.strike_price?` ₹${o.strike_price} ${o.option_type||''}` :''}
                              {o.expiry_date?` · ${new Date(o.expiry_date).toLocaleDateString('en-IN',{day:'2-digit',month:'short'})}`:''}
                            </td>
                            <td style={s.td}>{o.exchange}/{o.segment}</td>
                            <td style={{ ...s.td, color:o.side==='SELL'?'#DC2626':'#059669', fontWeight:600 }}>{o.side}</td>
                            <td style={s.td}>{o.quantity}</td>
                            <td style={s.td}>
                              <span style={{ fontSize:10, fontWeight:600, padding:'2px 8px', borderRadius:4, background:sb.bg, color:sb.col }}>{sb.label}</span>
                            </td>
                            <td style={{ ...s.td, fontSize:11, whiteSpace:'nowrap' }}>{fmtIST(o.placed_at)}</td>
                            <td style={{ ...s.td, fontSize:11 }}>{o.placed_by||'CLIENT'}{o.dealer_id?` (${o.dealer_id})`:''}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>}
          </div>
        )}
      </div>
    </div>
  );
}